import React from "react";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { useTheme } from "@mui/material";

const TextFormdDate = ({
    id,
    label,
    formik,
    hasTime = false
}) => {

    const format = hasTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD";
    const Component = hasTime ? DateTimePicker : DatePicker;
    const timeParams = hasTime ? { orientation: "landscape", ampm: false } : {};

    return (
        <Component
            label={label}
            format={format}
            value={formik.values[id]}
            clearable={true}
            showDaysOutsideCurrentMonth={true}
            disableCloseOnSelect={true}
            onChange={value => formik.setFieldValue(id, value)}
            showToolbar={true}
            required={false}
            {...timeParams}
            slotProps={
                {
                    textField: {
                        size: "small",
                        margin: "none",
                        fullWidth: true,
                        helperText: formik.touched[id] ? formik.errors[id] : "",
                        error: formik.touched[id] && Boolean(formik.errors[id])
                    }
                }
            }
        />
    )
}

export default TextFormdDate;
